import axios from "axios";
import FormData from "form-data";


const getToken = async () => {
    try {
        const token = localStorage.getItem("token");
        return token;
    } catch (error) {
        return null;
    }
};

class Api {
    constructor() {
        this.client = null;
        // this.api_url = process.env.NODE_ENV === "development" ? "https://pavitra-jewels-backend.onrender.com/api" : `https://pavitra-jewels-backend.onrender.com/api`;
        // this.api_url = process.env.NODE_ENV === "development" ? "https://admin.kingster.edu.in/pavitra/api" : `https://admin.kingster.edu.in/pavitra/api`;

        this.api_url = process.env.NODE_ENV === "development" ? "https://pavithra-api.duckdns.org/api" : `https://pavithra-api.duckdns.org/api`;
        // this.api_url = process.env.NODE_ENV === "development" ? "http://localhost:4000/api" : `http://localhost:4000/api`;
    }


    init = (type) => {

        let headers;

        headers = {
            Accept: "application/json",
        }

        if (type === "multipart/form-data") {
            headers = {
                'Content-Type': 'multipart/form-data',
            }
        }

        this.client = axios.create({
            baseURL: this.api_url,
            timeout: 31000,
            headers: headers,
        });

        this.client.interceptors.request.use(async (config) => {
            const token = await getToken();

            config.headers["Authorization"] = `Bearer ${token}`
            return config;
        }, (error) => {
            throw error;
        })

        return this.client;
    };


    // login
    getProfile = (data, config) => {
        return this.init().get("/user/userprofile", data)
    }
    login = (data) => {
        return this.init().post("/user/login", data)
    }
    verifyLogin = (data) => {
        return this.init().post("/user/verifyLogin", data)
    }
    loginWithPhone = (data) => {
        return this.init().post("/user/loginWithPhone", data)
    }
    verifyLoginWithPhone = (data) => {
        return this.init().post("/user/verifyLoginWithPhone", data)
    }
    resendOtpForLogin = (data) => {
        return this.init().post("/user/resendOtpForLogin", data)
    }
    resendOtpForLoginWithEmail = (data) => {
        return this.init().post("/user/resendOtpForLoginWithEmail", data)
    }

    createAccount = (data) => {
        return this.init().post("/user/register", data)
    }
    verifyOtp = (data) => {
        return this.init().post("/user/verify-phone-otp", data)
    }
    resendOtpForSignUp = (data) => {
        return this.init().post("/user/resendOtpForRegistration", data)
    }


    updateProfile = (data) => {
        return this.init().put(`/user/updateProfile`, data)
    }
    verifyEditProfileOtp = (data) => {
        return this.init().post(`/user/verifyEditProfileOtp`, data)
    }

    addShippingAddress = (data) => {
        return this.init().post(`/user/addShippingAddress`, data)
    }

    editShippingAddress = (data) => {
        return this.init().put(`/user/editShippingAddress`, data)
    }
    deleteShippingAddress = (data) => {
        return this.init().delete(`/user/deleteShippingAddress/${data}`, data)
    }
    deleteBillingAddress = (data) => {
        return this.init().delete(`/user/deleteBillingAddress/${data}`, data)
    }

    updateConfirmProfile = (data) => {
        return this.init().put(`/admin/confirm/edit-bio`, data)
    }
    updatePassword = (data) => {
        return this.init().put(`/admin/update-password`, data)
    }
    fileUpload = (data, config) => {
        return this.init('multipart/form-data').post("/admin/upload-file", data)
    }
    getPutSignedUrl = (data, config) => {
        return this.init('multipart/form-data').post("/user/get-put-url", data)
    }

    deleteProfileImage = () => {
        return this.init().delete(`/user/delete-profile-image`);
    }

    resetUnreadCounts = (data, config) => {
        return this.init().put("/user/resetUnreadCounts", data)
    }

    // Appearances 
    getAppearances = () => {
        return this.init().get('/user/appearances/getAllAppearances')
    }
    getGoldRate = () => {
        return this.init().get('/user/goldrate')
    }

    // Country 
    getActiveCountries = () => {
        return this.init().get(`/common/active-countries`)
    }

    //Products
    getAllProductsByCategory = (data) => {
        return this.init().get(`/user/product/getproductbycategory/${data}`)
    }
    getAllProductsById = (data) => {
        return this.init().get(`/user/product/getproductbyid/${data}`)
    }
    getPopularProduct = (data) => {
        return this.init().get('/user/product/get-popular-products')
    }
    increamentProductCount = (data) => {
        return this.init().post(`/user/product/inc-count/${data}`, data)
    }
    getProductsBySearch = (data) => {
        // console.log('data======',data);

        return this.init().get(`/user/searchproduct?${data}`, data)
    }

    //Wishlist
    getAllWishlist = (data) => {
        return this.init().get('/user/wishlist')
    }
    addWishlist = (data) => {
        return this.init().post('/user/wishlist', data)
    }
    updateWishlist = (data) => {
        return this.init().put('/user/wishlist', data)
    }
    deleteWishlist = (data) => {
        return this.init().delete(`/user/wishlist/${data}`, data)
    }
    //Carts
    getAllCarts = (data) => {
        return this.init().get('/user/cart')
    }
    addCarts = (data) => {
        return this.init().post('/user/cart', data)
    }
    updateCarts = (data) => {
        return this.init().put('/user/cart', data)
    }
    deleteCarts = (data) => {
        return this.init().delete(`/user/cart/${data}`, data)
    }

    //getAllCoupons
    getAllCoupons = (data) => {
        return this.init().get(`/user/getallcoupons${data}`)
    }
    applyCoupon = (data) => {
        return this.init().post('/user/applycoupons', data)
    }
    //Payemnt
    pinCodeValidation = (data) => {
        return this.init().post('/user/create-pincode-validation', data)
    }
    placeOrder = (data) => {
        return this.init().post('/user/placeOrder', data)
    }
    paymentStepOne = (data) => {
        return this.init().post('/user/paymentStepOne', data)
    }
    paymentStepOneHdfc = (data) => {
        return this.init().post('/user/paymentStepOneHdfc', data)
    }
    handlePaymentResponse = (data) => {
        return this.init().post('/user/handlePaymentResponse', data)
    }
    saveOrderDraft = (data) => {
        return this.init().post('/user/saveOrderDraft', data)
    }
    payRemainingprice = (data) => {
        return this.init().post('/user/payRemainingprice', data)
    }
    payRemainingpriceForMultiplleProduct = (data) => {
        return this.init().post('/user/payRemainingpriceForMultiplleProduct', data)
    }
    payPendingAmountHdfc = (data) => {
        return this.init().post('/user/payPendingAmountHdfc', data)
    }

    //orders--------------------------------------------------------------
    //-----------------------------

    getAllOrders = ({ page = 1, size = 10, sort = 'newest' } = {}) => {
        return this.init().get('/user/getAllorder', { params: { page, size, sort } });
    };
    getSubCategoryNames = (data) => {
        return this.init().get(`/user/getCategoryNames${data}`)
    }

    getFilteredProducts = (data) => {
        return this.init().get(`/user/products?${data}`)
    }
    getOrderDetails = (id) => {
        return this.init().get(`/user/orderDetails/${id}`)
    }
    writeReview = (data) => {
        return this.init().post('/user/reviews', data)
    }

    //contact us
    contactUs = (data) => {
        return this.init().post('/user/contactUs', data)
    }

    //getTermsCondition
    getTermsCondition = (data) => {
        return this.init().get('/user/getTermsAndCondition')
    }

    //getMaximumAmountOfProduct
    getMaximumAmountOfProduct = (data) => {
        return this.init().get('/user/get-max-product-price')
    }
}

const api = new Api();

export default api